document.addEventListener('DOMContentLoaded', function () {
  // Inject modal HTML
  const modalHTML = `
    <div id="lang-modal" class="lang-modal">
      <div class="lang-modal-content">
        <span class="close-lang">&times;</span>
        <h3>Vælg Sprog</h3>
        <ul>
          <li><a href="#" data-domain="soundstorexl.dk"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/denmark.png?v=1742990123" alt="Danish">Dansk</a></li>
          <li><a href="#" data-domain="soundstorexl.se"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/sweden.png?v=1742990968" alt="Swedish">Svensk</a></li>
          <li><a href="#" data-domain="soundstorexl.no"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/norway.png?v=1742991092" alt="Norway">Norsk</a></li>
          <li><a href="#" data-domain="soundstorexl.com"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/EU.png?v=1742991477" alt="EU">Engelsk</a></li>
          <li><a href="#" data-domain="soundstorexl.fi"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/findland.png?v=1742991571" alt="findland">Finsk</a></li>
          <li><a href="#" data-domain="soundstorexl.de"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/germany.png?v=1742990123" alt="German">Tysk</a></li>
          <li><a href="#" data-domain="soundstorexl.fr"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/france.png?v=1742992825" alt="France">Fransk</a></li>
          <li><a href="#" data-domain="soundstorexl.it"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/flag.png?v=1742992824" alt="Italy">Italiensk</a></li>
          <li><a href="#" data-domain="soundstorexl.es"><img class="lang-flag" src="https://cdn.shopify.com/s/files/1/0904/7120/3185/files/world.png?v=1742992825" alt="Spain">Spansk</a></li>
        </ul>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Inject styles
  const style = document.createElement('style');
  style.innerHTML = `
    .lang-modal {
      display: none;
      position: fixed;
      z-index: 9999;
      left: 0; top: 0;
      width: 100%; height: 100%;
      background: rgba(0, 0, 0, 0.6);
    }
    .lang-modal-content {
      background: white;
      max-width: 300px;
      margin: 10% auto;
      padding: 20px;
      border-radius: 10px;
      text-align: center;
    }
    .lang-modal-content ul {
      list-style: none;
      padding: 0;
      margin: 20px 0 0;
    }
    .lang-modal-content li {
      margin: 10px 0;
    }
    .lang-modal-content a {
      color: #000;
      text-decoration: none;
      font-weight: bold;
    }
    .lang-modal-content a:hover {
      text-decoration: underline;
    }
    .close-lang {
      float: right;
      font-size: 20px;
      cursor: pointer;
    }
    .lang-flag {
      width: 24px;
      height: 16px;
      object-fit: cover;
      margin-right: 10px;
      border-radius: 2px;
    }
  `;
  document.head.appendChild(style);

  // Event logic
  const trigger = document.getElementById('open-lang-selector');
  const closeLang = () => document.getElementById('lang-modal').style.display = 'none';

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('lang-modal').style.display = 'block';
    });
  }

  document.body.addEventListener('click', function (e) {
    if (e.target.classList.contains('close-lang') || e.target.id === 'lang-modal') {
      closeLang();
    }
  });

  // Redirect logic
  document.body.addEventListener('click', function (e) {
    if (e.target.matches('.lang-modal-content a[data-domain]')) {
      e.preventDefault();
      const newDomain = e.target.getAttribute('data-domain');
      const currentPath = window.location.pathname;
      const safePaths = ['/pages/blogs', '/pages/faq', '/apps', '/policies'];
      const isSafe = safePaths.some(path => currentPath.startsWith(path) || currentPath.includes(path));
      const newUrl = isSafe
        ? `https://${newDomain}${currentPath}${window.location.search}${window.location.hash}`
        : `https://${newDomain}`;
      window.location.href = newUrl;
    }
  });
});